
import { mapGetters } from "vuex";
import seoTags from "@/mixins/seoTags";

export default {
  mixins: [seoTags],
  middleware: 'check-catalog-route',

	validate(ctx) {
		return ctx.params.category === 'cars' || ctx.params.category === 'new';
	},
	computed: {
		...mapGetters({
			componentCatalog: 'filters/filters/componentCatalog',
		}),
		currentComponent() {
      if (this.componentCatalog === 'car') {
        return this.$device.isMobile
          ? 'car2'
          : 'car2-desktop';
      } else {
        return 'catalog-used';
      }
		},
	},
	watch:{
		componentCatalog(value){
			// console.log('componentCatalog',value)
		}
	}
}
